export const MenuItemsResourcesBS: MenuItemsResourcesInterface = {
  mainMenuItems: {
    home: {
      title: "Evidentiranje",
      subMenuItems: {
        planiranizadaci: "Planirani zadaci",
        evidencijapopotrebi: "Evidencija po potrebi",
        prijavaodjava: "Radno vrijeme",
        prijavaodjavaGPS: "Radno vrijeme GPS",
        prijavaodjavaGPSManager: "Radno vrijeme GPS - Menadžer",
        feedbackReview: "Pregled feedbacka",
        monitoringDashboard: "Monitoring Dashboard",
        fileUpload: "Upload datoteka",
      },
    },
    users: {
      title: "Korisnici",
      subMenuItems: {
        dodavanjeKorisnika: "Dodavanje Korisnika",
        upravljanjeKorisnicima: "Upravljanje Korisnicima",
      },
    },
    kompanija: {
      title: "Kompanija",
      subMenuItems: "",
    },
    evidencija: {
      title: "Evidencija",
      subMenuItems: "",
    },
    statistika: {
      title: "Statistika",
      subMenuItems: "",
    },
    radnovrijeme: {
      title: "Radno vrijeme",
      subMenuItems: "",
    },
    pohvaleikritike: {
      title: "Pohvale i kritike",
      subMenuItems: "",
    },
    administracija: {
      title: "Administracija",
      subMenuItems: {
        recordPoint: "Arhitektura",
        register: "Kompanije",
        users: "Korisnici",
        recordsSettings: "Katalog evidencija",
        qrCodes: "QR Kodovi",
        neradniDan: "Neradni dan",
      },
    },
    lists: {
      title: "Pregled evidencija",
      listaKompanija: "Kompanije",
      listaEvidencija: "Evidencije",
      listaRadnogVremena: "Radno vrijeme",
      listaRadnogVremenaSum: "Sihtarica (odobri)",
      pregledSihtarica: "Pregled sihtarica",
      listaRadnogVremenaGps: "Lista radnog vremena GPS",
      listaSanEvd: "Lista sanitarnih evidencija",
      imagePage: "Stranica slika",
      listDocuments: "Lista dokumenata",
    },
    footer: {
      title: "Impressum",
      submenuItems: {
        aboutus: "O nama",
      },
    },
  },
};

export const MenuItemsResourcesEN: MenuItemsResourcesInterface = {
  mainMenuItems: {
    home: {
      title: "Recording",
      subMenuItems: {
        planiranizadaci: "Scheduled tasks",
        evidencijapopotrebi: "Evidence as needed",
        prijavaodjava: "Working time",
        prijavaodjavaGPS: "Working time GPS",
        prijavaodjavaGPSManager: "Working time GPS - Manager",
        feedbackReview: "Feedback Review",
        monitoringDashboard: "Monitoring Dashboard",
        fileUpload: "File Upload",
      },
    },
    users: {
      title: "Users",
      subMenuItems: {
        dodavanjeKorisnika: "Add User",
        upravljanjeKorisnicima: "User Management",
      },
    },
    kompanija: {
      title: "Company",
      subMenuItems: "",
    },
    evidencija: {
      title: "Evidence",
      subMenuItems: "",
    },
    statistika: {
      title: "Statistics",
      subMenuItems: "",
    },
    radnovrijeme: {
      title: "Working Time",
      subMenuItems: "",
    },
    pohvaleikritike: {
      title: "Feedback",
      subMenuItems: "",
    },
    administracija: {
      title: "Administration",
      subMenuItems: {
        recordPoint: "Architecture",
        register: "Companies",
        users: "Users",
        recordsSettings: "Evidence Catalog",
        qrCodes: "QR Codes",
        neradniDan: "Non-working day",
      },
    },
    lists: {
      title: "Evidence Overview",
      listaKompanija: "Companies",
      listaEvidencija: "Evidence",
      listaRadnogVremena: "Working Time",
      listaRadnogVremenaSum: "Timesheet (approve)",
      pregledSihtarica: "Timesheet review",
      listaRadnogVremenaGps: "Working Time GPS List",
      listaSanEvd: "Sanitary Evidence List",
      imagePage: "Image page",
      listDocuments: "List Documents",
    },
    footer: {
      title: "About Us",
      submenuItems: {
        aboutus: "About Us",
      },
    },
  },
};

export const MenuItemsResourcesDE: MenuItemsResourcesInterface = {
  mainMenuItems: {
    home: {
      title: "Erfassung",
      subMenuItems: {
        planiranizadaci: "Geplante Aufgaben",
        evidencijapopotrebi: "Evidenz nach Bedarf",
        prijavaodjava: "Arbeitszeit",
        prijavaodjavaGPS: "Arbeitszeit GPS",
        prijavaodjavaGPSManager: "Arbeitszeit GPS - Manager",
        feedbackReview: "Feedback-Übersicht",
        monitoringDashboard: "Monitoring Dashboard",
        fileUpload: "Datei hochladen",
      },
    },
    users: {
      title: "Benutzer",
      subMenuItems: {
        dodavanjeKorisnika: "Benutzer hinzufügen",
        upravljanjeKorisnicima: "Benutzerverwaltung",
      },
    },
    kompanija: {
      title: "Unternehmen",
      subMenuItems: "",
    },
    evidencija: {
      title: "Evidenz",
      subMenuItems: "",
    },
    statistika: {
      title: "Statistiken",
      subMenuItems: "",
    },
    radnovrijeme: {
      title: "Arbeitszeit",
      subMenuItems: "",
    },
    pohvaleikritike: {
      title: "Feedback",
      subMenuItems: "",
    },
    administracija: {
      title: "Administration",
      subMenuItems: {
        recordPoint: "Architektur",
        register: "Unternehmen",
        users: "Benutzer",
        recordsSettings: "Evidenz-Katalog",
        qrCodes: "QR-Codes",
        neradniDan: "Arbeitsfreier Tag",
      },
    },
    lists: {
      title: "Evidenz-Übersicht",
      listaKompanija: "Unternehmen",
      listaEvidencija: "Evidenz",
      listaRadnogVremena: "Arbeitszeit",
      listaRadnogVremenaSum: "Arbeitszeit (genehmigen)",
      pregledSihtarica: "Arbeitszeitübersicht",
      listaRadnogVremenaGps: "Arbeitszeit GPS Liste",
      listaSanEvd: "Sanitäre Evidenzliste",
      imagePage: "Bilderseite",
      listDocuments: "Dokumentenliste",
    },
    footer: {
      title: "Über uns",
      submenuItems: {
        aboutus: "Über uns",
      },
    },
  },
};

export interface MenuItemsResourcesInterface {
  mainMenuItems: {
    home: {
      title: string;
      subMenuItems: {
        planiranizadaci: string;
        evidencijapopotrebi: string;
        prijavaodjava: string;
        prijavaodjavaGPS: string;
        prijavaodjavaGPSManager: string;
        feedbackReview: string;
        monitoringDashboard: string;
        fileUpload: string;
      };
    };
    users: {
      title: string;
      subMenuItems: {
        dodavanjeKorisnika: string;
        upravljanjeKorisnicima: string;
      };
    };
    kompanija: {
      title: string;
      subMenuItems: string; // You may want to change this to an object with sub-menu items
    };
    evidencija: {
      title: string;
      subMenuItems: string; // You may want to change this to an object with sub-menu items
    };
    statistika: {
      title: string;
      subMenuItems: string; // You may want to change this to an object with sub-menu items
    };
    radnovrijeme: {
      title: string;
      subMenuItems: string; // You may want to change this to an object with sub-menu items
    };
    pohvaleikritike: {
      title: string;
      subMenuItems: string; // You may want to change this to an object with sub-menu items
    };
    administracija: {
      title: string;
      subMenuItems: {
        recordPoint: string;
        register: string;
        users: string;
        recordsSettings: string;
        qrCodes: string;
        neradniDan: string;
      };
    };
    lists: {
      title: string;
      listaKompanija: string;
      listaEvidencija: string;
      listaRadnogVremena: string;
      listaRadnogVremenaSum: string;
      pregledSihtarica: string;
      listaRadnogVremenaGps: string;
      listaSanEvd: string;
      imagePage: string;
      listDocuments: string;
    };
    footer: {
      title: string;
      submenuItems: {
        aboutus: string;
      };
    };
  };
}
